<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;">CONTENTS</h2>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/9780312340391_ack#ack">Acknowledgments</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><a href="#/9780312340391_fm02#fm02">Introduction</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/9780312340391_ch01#ch01">1 The Park Avenue Mind-Set</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><a href="#/9780312340391_ch02#ch02">2 Protein—The Anchor of Your Diet</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312340391_ch03#ch03" title="Link target outside of Sample">3 Calcium—The Miracle Mineral</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312340391_ch04#ch04" title="Link target outside of Sample">4 Dr. Klauer’s Diet Plan</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312340391_ch05#ch05" title="Link target outside of Sample">5 Curb Your Cravings: The Stop! Watch! Method</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312340391_ch06#ch06" title="Link target outside of Sample">6 The Stop! Watch! Method of Exercise</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312340391_ch07#ch07" title="Link target outside of Sample">7 Anti-Aging Nutrition: Live Longer and Look Younger</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312340391_ch08#ch08" title="Link target outside of Sample">8 Your Outside Is a Mirror of Your Inside</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%;"><span href="#/9780312340391_ch09#ch09" title="Link target outside of Sample">9 Dr. Klauer’s Recipes</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780312340391_bm01#bm01" title="Link target outside of Sample">Glossary</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780312340391_bm02#bm02" title="Link target outside of Sample">Resources</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780312340391_bm03#bm03" title="Link target outside of Sample">Notes</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9780312340391_bm04#bm04" title="Link target outside of Sample">Index</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312340391_con01.vue?54bcff68